import moment from "moment/moment";
import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import ReactPaginate from "react-paginate";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { editIcon, viewIcon } from "../../assets/img";
import { useLazyRequestPropertyStatusQuery } from "../../redux/api/api";
import { saveLoader } from "../../redux/slice/loaderNoti";

const Property = ({
  listProperty,
  paginationProperty,
  rowProperty,
  setPropertyPage,
  propertyCount,
  getProperty,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [btn, setBtn] = useState(false);

  const handlePageChange = (selectedObject) => {
    setPropertyPage(selectedObject.selected + 1);
  };

  // RTK QUERY
  const [requestPropertyStatusApi] = useLazyRequestPropertyStatusQuery();

  const statusChange = (property_id) => {
    dispatch(saveLoader(true));
    setBtn(true);
    requestPropertyStatusApi(property_id)
      .unwrap()
      .then((res) => {
        dispatch(saveLoader(false));
        setBtn(false);
        if (res?.status == "success") {
          Swal.fire({
            text: res?.message,
            icon: "success",
          });
          getProperty(rowProperty);
        }
      })
      .catch((err) => {
        dispatch(saveLoader(false));
        setBtn(false);
        console.log("err");
      });
  };

  return (
    <div>
      <div className="d-flex ac-jb">
        <div className="col-md-2 p-0">
          <label className="table-labels f1">
            Total Count : {paginationProperty?.total}
          </label>
          <select
            className="form-control custom-select"
            onChange={(e) => getProperty(e.target.value)}
            value={rowProperty}
          >
            <option value={10}>10</option>
            <option value={25}>25</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select>
        </div>
      </div>
      <div className="table-custom-design overflow-scroll">
        <table>
          <thead>
            <tr className="text-capitalize text-nowrap">
              <th>S.NO</th>
              <th>Date</th>
              <th>Property Id</th>
              <th>Property Name</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {listProperty?.map((item, ind) => {
              return (
                <tr key={ind}>
                  <td>
                    {(paginationProperty?.current_page - 1) * rowProperty +
                      ind +
                      1}
                  </td>
                  <td>
                    {item?.created_at
                      ? moment(item?.created_at).format("DD-MM-YYYY hh:mm a")
                      : "-"}
                  </td>
                  <td>
                    <button
                      className="link-btn"
                      onClick={() => {
                        navigate("/property-view", {
                          state: { type: "edit", data: item },
                        });
                      }}
                    >
                      {item?.property_id}
                    </button>
                  </td>
                  <td>{item?.name}</td>
                  <td>
                    <button
                      className={`${
                        item?.status == 1 ? "btn-success" : "btn-danger"
                      } px-2 py-1 rounded-1 border-0 text-white`}
                      onClick={() => {
                        if (item?.status !== 4) {
                          statusChange(item?.id);
                        }
                      }}
                      disabled={btn}
                    >
                      {item?.status == 4
                        ? "Blocked Today"
                        : item?.status == 1
                        ? "Active"
                        : item?.status == 2
                        ? "Rejected"
                        : "Deactive"}
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <div className="page-inner-cont py-2 d-flex justify-content-end">
        <ReactPaginate
          nextLabel="››"
          onPageChange={handlePageChange}
          pageRangeDisplayed={2}
          marginPagesDisplayed={2}
          pageCount={propertyCount}
          previousLabel="‹‹"
          pageClassName="page-item"
          pageLinkClassName="page-link"
          previousClassName="page-item"
          previousLinkClassName="page-link"
          nextClassName="page-item"
          nextLinkClassName="page-link"
          breakLabel="..."
          breakClassName="page-item"
          breakLinkClassName="page-link"
          containerClassName="pagination"
          activeClassName="active"
          renderOnZeroPageCount={null}
        />
      </div>
    </div>
  );
};

export default Property;
